import Container from '@/components/Container/Container'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

export default {
  name: 'Index',
  components: {
    Container,
    FontAwesomeIcon
  },
  computed: {
    ...mapGetters({
      isStaff: 'isStaff'
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Index/script.js